/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import storage from 'app/services/session';
import { Svg, Image } from 'app/components';
import { Inner, Title, Info, Label, RowButton, Code, RowCode } from './styles';
import Ticket from '../Ticket';
import withTicket from '../withTicket';
import SelectionTotal from '../SelectionTotal';
import withSelection from '../withSelection';

const TicketWrapped = withTicket('booking')(Ticket);
const SelectionTotalWrapper = withSelection('booking')(SelectionTotal);

const propTypes = {
  title: PropTypes.string,
  info: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,

  booking: PropTypes.shape({
    bookingId: PropTypes.string.isRequired,
    isPaid: PropTypes.bool.isRequired
  }),

  code: PropTypes.string,

  fetch: PropTypes.func.isRequired,
  fetchCode: PropTypes.func.isRequired,
  clearBooking: PropTypes.func.isRequired,
  clearCode: PropTypes.func.isRequired,
  children: PropTypes.node,
  withHeader: PropTypes.bool,
  withDescription: PropTypes.bool,
  getTickets: PropTypes.func
};

const defaultProps = {
  title: null,
  withHeader: true,
  withDescription: false,
  code: null,
  booking: null,
  children: null,
  getTickets: null
};

const Order = ({
  title,
  info,
  label,
  booking,
  code,
  fetch,
  fetchCode,
  clearCode,
  children,
  withHeader,
  clearBooking,
  withDescription,
  getTickets
}) => {
  useEffect(() => {
    if (
      !booking &&
      (storage.getIsAppliedBonusGiftCard() === 'false' ||
        storage.getIsLastBonusCardRecharge() === 'true')
    ) {
      // debugger
      // fetch();
    }

    if (storage.getIsAppliedBonusGiftCard() === 'true') {
      // debugger
      // if (getTickets) getTickets();
    }

    return () => {
      clearBooking();
      storage.setIsAppliedBonusGiftCard(false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (booking) {
      const { bookingId, isPaid } = booking;
      fetchCode(isPaid, bookingId);
    }
    return () => clearCode();
  }, [clearBooking, booking ? '' : booking]);

  return booking && code ? (
    <Inner>
      {withHeader ? (
        <Fragment>
          <Svg id="complete" />
          <Title>{title}</Title>
        </Fragment>
      ) : null}

      <TicketWrapped type="compact">
        <SelectionTotalWrapper withDescription={withDescription} />
        <Label>{label}</Label>
        <Info>{info}</Info>

        <RowCode>
          <Code>
            <Image src={code} />
            <p>{booking.bookingId}</p>
          </Code>
        </RowCode>

        <RowButton>{children}</RowButton>
      </TicketWrapped>
    </Inner>
  ) : null;
};

Order.defaultProps = defaultProps;
Order.propTypes = propTypes;
export default Order;
